// These leave types are valid to apply, but they have no leave allocation,
// so /users/getLeaveAllocation omits them from the create-leave dropdown.
export const LEAVE_TYPES_WITHOUT_ALLOCATION = ['Business Travelling Leave']

export function includeLeaveTypesWithoutAllocation(types: any[] | null | undefined): any[] {
    const list = Array.isArray(types) ? [...types] : []
    for (const name of LEAVE_TYPES_WITHOUT_ALLOCATION) {
        const exists = list.some((item) => (typeof item === 'string' ? item : item?.value) === name)
        if (!exists) {
            list.push({ value: name })
        }
    }
    return list
}
